<div class="carousel-container">
  <!-- Slides -->
  <div
    *ngFor="let slide of slides; let i = index"
    class="slide"
    [class.active]="i === currentSlide"
    [class.prev]="i < currentSlide"
    [class.next]="i > currentSlide"
  >
    <!-- Background Image -->
    <div
      class="slide-background"
      [style.background-image]="'url(' + slide.image + ')'"
    >
      <!-- Dark Overlay -->
      <div class="overlay"></div>
    </div>

    <!-- Content -->
    <div class="slide-content">
      <div class="content-wrapper">
        <h1 class="title">{{ slide.title }}</h1>
        <p class="description">{{ slide.description }}</p>
        <!-- <button class="cta-button">Get Started</button> -->
      </div>
    </div>
  </div>

  <!-- Navigation Arrows -->
  <button
    class="nav-arrow left"
    (click)="prevSlide()"
    aria-label="Previous slide"
  >
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
    >
      <polyline points="15 18 9 12 15 6"></polyline>
    </svg>
  </button>
  <button class="nav-arrow right" (click)="nextSlide()" aria-label="Next slide">
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
    >
      <polyline points="9 18 15 12 9 6"></polyline>
    </svg>
  </button>

  <!-- Dots Indicator -->
  <div class="dots-container">
    <button
      *ngFor="let slide of slides; let i = index"
      class="dot"
      [class.active]="i === currentSlide"
      (click)="goToSlide(i)"
      [attr.aria-label]="'Go to slide ' + (i + 1)"
    ></button>
  </div>
</div>
